import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";

import {
  ACRActions,
  createACRSuccess,
  createACRFailed,
  getACRHistorySuccess,
  getACRHistoryFailed,
  deleteACRHistorySuccess,
  deleteACRHistoryFailed,
} from "@actions/HRM/employee/acr-actions";
import {
  CREATE_ACR,
  GET_ACRS_HISTORY,
  DELETE_ACR_HISTORY,
} from "@actions/HRM/employee/types";
import { isRequestCancelled } from "@helpers/routing";
import { StoreType } from "@reducers/types";
import { createACR, getACRHistory, deleteACRHistory } from "@api/acr";

export const acrMiddleware: Middleware<Record<string, unknown>, StoreType> = ({
  dispatch,
}: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: ACRActions) => {
      const nextAction = next(action);
      switch (action.type) {
        case GET_ACRS_HISTORY.GET_ACR_HISTORY_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await getACRHistory(payload?.data);

            dispatch(getACRHistorySuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(getACRHistoryFailed());
            }
          }
          break;
        }
        case DELETE_ACR_HISTORY.DELETE_ACR_HISTORY_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteACRHistory(payload);

            dispatch(deleteACRHistorySuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteACRHistoryFailed());
            }
          }
          break;
        }
        case CREATE_ACR.CREATE_ACR_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await createACR(payload);

            dispatch(createACRSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(createACRFailed());
            }
          }
          break;
        }
      }
      return nextAction;
    };
  };
};
